module.exports = __webpack_public_path__ + "img/zd-up-3.d1951f6c.svg";